import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=2a76faed&scoped=true&"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=2a76faed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76faed",
  null
  
)

component.options.__file = "Help.vue"
export default component.exports